import React from "react";
import styled from "@emotion/styled";
import { ThemeContext } from "../../contexts/Context";

const DotContainer = styled.div`
  display: grid;
  box-sizing: border-box;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 50%;
  flex-shrink: 0;
  border-color: ${(props) => props.activeState ? props.borderColor : `color-mix(in srgb, ${props.borderColor} 30%, ${props.backgroundColor || "#fff"})`};
`;
const Dot = styled.div`
  background-color: ${(props) => props.selectedColor};
  width: 12px;
  height: 12px;
  border-radius: 12px;
`;

const DotButton = ({
  activeState,
  setActiveState,
  produceNewState,
  title,
  array,
}) => {
  const { primaryColor, backgroundColor } = React.useContext(ThemeContext);
  return (
    <DotContainer
      borderColor={primaryColor}
      backgroundColor={backgroundColor}
      activeState={activeState}
      onClick={() => {
        title
          ? setActiveState(produceNewState(array, title))
          : setActiveState(activeState);
      }}
    >
      {activeState ? <Dot selectedColor={primaryColor} /> : <React.Fragment />}
    </DotContainer>
  );
};

export default DotButton;
